import { BudgetScenarioWorktypeOption } from '@callmart/types';
import api from './index';

const BASE = '/budget-scenarios';

export interface ScenarioBudgetAdjustmentValue {
    month: string; // 'YYYY-MM-DD'
    amount: number; // euro change; negative = budget reduction (Budgetchallenge)
}

export interface ScenarioBudgetAdjustmentResponse {
    /** The scenario's `updatedAt` AS OF this read — the revision the form's next PATCH must send with THESE
     *  values (see ScenarioContactValuesResponse.revision for why the scenario query cannot supply it). */
    revision: string;
    values: ScenarioBudgetAdjustmentValue[];
    scopeWorktypeIds: number[];
    availableWorktypes: BudgetScenarioWorktypeOption[];
}

/** `versionId` is the version the OPTION lists must describe — the DRAFT one while the detail form's
 *  Budget select is pointed elsewhere, so the pickers stay in step with the impact preview (which is
 *  already priced against that version). Omitted, the server answers from the scenario's stored one. */
export const getScenarioBudgetAdjustment = async (
    scenarioId: number,
    versionId?: number
): Promise<ScenarioBudgetAdjustmentResponse> => {
    return api.get(`${BASE}/${scenarioId}/budget-adjustment-values`, { params: { versionId } }).then((res) => res.data);
};
